import LoginModalComponent from './LoginModal'

function LoginModal(Vue) {

  const vueInstance = new Vue({
    render(h){
      return h(LoginModalComponent, { })
    }
  })
  const component = vueInstance.$mount()
  document.body.appendChild(component.$el)
  const loginModal = vueInstance.$children[0];

  function show(params={}){
    loginModal.show(params)
  }

  function hide(){
    loginModal.hide()
  }

  const ctx = {
    show,
    hide
  }
  return ctx
}

export default function(){
  return {
    install(Vue){
      const $loginModal = new LoginModal(Vue)
      Vue.prototype.$loginModal = $loginModal
    }
  }
}
